module.exports = "<div ui-view=main></div>";


//////////////////
// WEBPACK FOOTER
// ./~/@abosol/masterdata/src/masterdata.html
// module id = 375
// module chunks = 1